import { AI_SUGGESTION_MODE } from 'src/data/generation';

// We don't display some common buttons:
// * "guided" - has it's own logic of displaying
export const filterVisibleDDTemplates = (modes) => {
  const serviceModes = [AI_SUGGESTION_MODE.guided, AI_SUGGESTION_MODE.customFormula];
  return modes.filter((mode) => !serviceModes.includes(mode));
};
